import ukLocale from 'antd/es/locale/uk_UA'
import ptBrLocale from 'antd/es/locale/pt_BR'
import ptLocale from 'antd/es/locale/pt_PT'
import itLocale from 'antd/es/locale/it_IT'
import esLocale from 'antd/es/locale/es_ES'
import enLocale from 'antd/es/locale/en_US'

const Locales = {
  'en-us': enLocale,
  'pt-pt': ptLocale,
  'pt-br': ptBrLocale,
  it: itLocale,
  es: esLocale,
  uk: ukLocale
}
export const getLocale = () => {
  const localEs = 'es'
  const local = window.local?.split('-')[0] === localEs ? localEs : window.local
  return Locales[local] ?? enLocale
}
